<template>
  <section>
    <h3 class="primary--text">
      <v-icon color="primary">people</v-icon>
      Ficha personal
    </h3>
    <v-card v-if="persona === null" elevation="0">
      <v-card-text class="text-md-center">
        <v-progress-circular
          :size="70"
          :width="7"
          color="primary"
          indeterminate
        ></v-progress-circular>
      </v-card-text>
    </v-card>
    <v-card v-if="persona !== null" elevation="0">
      <v-card-text>
        <p><strong>Nombre completo: </strong>{{ persona.nombres }} {{ persona.ap_paterno }} {{ persona.ap_materno }}</p>
        <p><strong>Número de documento: </strong>{{ persona.nro_doc }}</p>
        <p><strong>Sexo: </strong>{{ recuperarSexo(persona.id_genero) }}</p>
        
        <v-flex md3>Foto
          <div id="preview">
            <img v-if="img_url" :src="img_url" height="150" width="150" />
            
          </div>
        </v-flex>
      </v-card-text>
      <v-card-text>
        <v-tabs
          v-model="active"
          class="tab-preferencias"
          color="info"
          dark
          slider-color="warning"
         
          show-arrows
        >
          <!-- Tabs -->
          
          <v-tab
            key="datos-personales-basicos"
            href="#datos-personales-basicos"
            ripple
          >
            Datos personales Básicos
          </v-tab>
          <!-- <v-tab key="datos-personales" href="#datos-personales" ripple>
            Datos personales
          </v-tab> -->
          <v-tab key="cas" href="#cas" ripple> 
            Calificacion de Años de Servicio</v-tab>
          <v-tab key="declaracion-jurada" href="#declaracion-jurada" ripple>
            Declaracion jurada
          </v-tab>
          <v-tab key="inamovilidad" href="#inamovilidad" ripple>
            Inamovilidad
          </v-tab>
          <v-tab key="datos-familiares" href="#datos-familiares" ripple>
            Datos familiares
          </v-tab>
          <v-tab key="formacion-academica" href="#formacion-academica" ripple>
            Formación
          </v-tab>
          <v-tab key="experiencia-trabajo" href="#experiencia-trabajo" ripple>
            Experiencia de trabajo
          </v-tab>
          <v-tab key="cursos-capacitacion" href="#cursos-capacitacion" ripple>
            Cursos de capacitación
          </v-tab>
          <v-tab key="idiomas" href="#idiomas" ripple> Idiomas </v-tab>
          <v-tab key="documentos-adjuntos" href="#documentos-adjuntos" ripple prev-icon='$vuetify.icons.prev'>
            Documentos adjuntos
          </v-tab>
           <v-tab key="observaciones" href="#observaciones" ripple prev-icon='$vuetify.icons.prev'>
            
            Observaciones 
           
          </v-tab>
          <v-tab key="finalizar" href="#finalizar" ripple prev-icon='$vuetify.icons.prev'>
            Finalizar
          </v-tab>
          
          <!-- Componentes -->
          <v-tab-item
            key="datos-personales-basicos"
            value="datos-personales-basicos"
          >
            <v-card flat>
              <datos-personales-basicos
                v-if="active == 'datos-personales-basicos'" :persona="persona"
              />
            </v-card>
          </v-tab-item>
          <!-- <v-tab-item key="datos-personales" value="datos-personales">
            <v-card flat>
              <datos-personales v-if="active == 'datos-personales'" />
            </v-card>
          </v-tab-item> -->
          <v-tab-item key="cas" value="cas">
            <v-card flat>
              <cas v-if="active == 'cas'" :persona="persona"/>
            </v-card>
          </v-tab-item>
          <v-tab-item key="declaracion-jurada" value="declaracion-jurada">
            <v-card flat>
              <declaracion-jurada v-if="active == 'declaracion-jurada'" :persona="persona"/>
            </v-card>
          </v-tab-item>
          <v-tab-item key="inamovilidad" value="inamovilidad">
            <v-card flat>
              <inamovilidad v-if="active == 'inamovilidad'" :persona="persona"/>
            </v-card>
          </v-tab-item>
          <v-tab-item key="datos-familiares" value="datos-familiares">
            <v-card flat>
              <datos-familiares v-if="active == 'datos-familiares'" :persona="persona"/>
            </v-card>
          </v-tab-item>
          <v-tab-item key="formacion-academica" value="formacion-academica">
            <v-card flat>
              <formacion-academica v-if="active == 'formacion-academica'" :persona="persona" />
            </v-card>
          </v-tab-item>
          <v-tab-item key="experiencia-trabajo" value="experiencia-trabajo">
            <v-card flat>
              <experiencia-trabajo v-if="active == 'experiencia-trabajo'" :persona="persona"/>
            </v-card>
          </v-tab-item>
          <v-tab-item key="cursos-capacitacion" value="cursos-capacitacion">
            <v-card flat>
              <cursos-capacitacion v-if="active == 'cursos-capacitacion'" :persona="persona"/>
            </v-card>
          </v-tab-item>
          <v-tab-item key="idiomas" value="idiomas">
            <v-card flat>
              <idiomas v-if="active == 'idiomas'" :persona="persona"/>
            </v-card>
          </v-tab-item>
          <v-tab-item key="documentos-adjuntos" value="documentos-adjuntos">
            <v-card flat>
              <documentos-adjuntos v-if="active == 'documentos-adjuntos'" :persona="persona"/>
            </v-card>
          </v-tab-item>
          <v-tab-item key="observaciones" value="observaciones">
            
            <v-card flat>
              <observaciones v-if="active == 'observaciones'" :persona="persona"/>
              
            </v-card>
          </v-tab-item>
           <v-tab-item key="finalizar" value="finalizar">
            <v-card flat>
              <finalizar v-if="active == 'finalizar'" :persona="persona"/>
            </v-card>
          </v-tab-item>
        </v-tabs>
      </v-card-text>
    </v-card>
  </section>
</template>

<script>
import Cas from "./components/Cas.vue";
import CursosCapacitacion from "./components/CursosCapacitacion.vue";
import DatosFamiliares from "./components/DatosFamiliares.vue";
import DatosPersonales from "./components/DatosPersonales.vue";
import DatosPersonalesBasicos from "./components/DatosPersonalesBasicos.vue";
import DocumentosAdjuntos from "./components/DocumentosAdjuntos.vue";
import ExperienciaTrabajo from "./components/ExperienciaTrabajo.vue";
import FormacionAcademica from "./components/FormacionAcademica.vue";
import Idiomas from "./components/Idiomas.vue";
import Finalizar from "./components/Final.vue";
import Observaciones from "./components/Observaciones.vue";

import DeclaracionJurada from "./components/DeclaracionJurada.vue";
import Inamovilidad from "./components/Inamovilidad.vue";

export default {
  data() {
    return {
      active: "datos-personales-basicos",
      persona: null,
      loading: false,
      img_url: ""
    };
  },
  mounted() {
    // Verificando si el usuario tiene permiso para interactual con el componente
    const rolesPermitidos = [0]; // ID's de roles permitidos
    this.getImagen()
    if (!this.$util.permisoRol(rolesPermitidos)) {
      this.$router.push("/403");
    }
    if (this.$route.params.id) {
      this.obtenerPersona(this.$route.params.id)
    } else {
      let user = this.$storage.get('user')
      this.obtenerPersona(user.id_persona)
    }
    
  },
  components: {
    DatosPersonalesBasicos,
    DatosPersonales,
    Cas,
    DatosFamiliares,
    FormacionAcademica,
    ExperienciaTrabajo,
    CursosCapacitacion,
    DocumentosAdjuntos,
    Idiomas,
    DeclaracionJurada,
    Inamovilidad,
    Finalizar,
    Observaciones,
  },
  methods: {
    cargarImagen() {
      this.sw = true;
      this.imagen = this.$refs.file.files[0];
      const img = this.imagen;

      const extenciones = ["png", "jpeg", "jpg", "gif"];
      let nm = img.name.split(".");

      const maxSize = 2000000;
      const extencion = nm[nm.length - 1];
      if (
        extenciones.filter((e) => e == extencion).length > 0 &&
        this.imagen.size <= maxSize
      ) {
        this.img_url = URL.createObjectURL(this.imagen);
        this.img_error = false;
        this.img_error_message = "";
      } else {
        if (extenciones.filter((e) => e == extencion).length == 0) {
          this.img_error = true;
          this.img_error_message = "Imagen no valida.";
        } else if (this.imagen.size > maxSize) {
          this.img_error = true;
          this.img_error_message = "La imagen excede el tamaño permitido.";
        }
      }
    },
     async getImagen() {
      //this.img_url = require("../../../../assets/images/Usariosinimagen.png");
      let id
      try {

          if(this.$route.params.id!=null){
             let a = this.$route.params.id; 
             id=a;
          }else{
              const user = this.$storage.get("user");
              let b = user.id_persona;
              id=b
          }
        
        
        

        let respuesta = await this.$service.graphql({
          query: `
           query{
              persona(id:${id}){
                  foto   
              }
            }
          `,
        });
        let url = process.env.API_URL;
        url = url.substring(0, url.length - 4);
        console.log("url "+url);
        if (respuesta.persona.foto != null) {
          this.img_url = url + respuesta.persona.foto;
          console.log("img_url "+img_url);
        }
      } catch (error) {
        console.log(error);
        //this.img_url = require("../../../../assets/images/Usariosinimagen.png");
      }
    },

    async obtenerPersona (id_persona) {
      try {
          let res = await this.$service.graphql({
            query: `
              query{
                persona(id: ${id_persona}){
                  id
                  nombres
                  ap_paterno
                  ap_materno
                  ap_casada
                  nro_doc
                  nro_complemento
                  pais_nacimiento
                  nacionalidad
                  ciudad_residencia
                  sexo
                  direccion
                  telefono_domicilio
                  telefono_alternativo
                  celular
                  nro_licencia_conducir
                  grupo_sanguineo
                  foto
                  afp
                  nro_nua
                  banco
                  nro_cuenta_bancaria
                  libreta_serv_militar
                  nro_registro
                  anio_serv_militar
                  fecha_nacimiento
                  expedido
                  colegio_profesional
                  nro_registro_profesional
                  fecha_reg_profesional
                  id_parametro_estado_civil
                  id_parametro_grupo_sanguineo
                  id_parametro_entidad_previsora
                  id_parametro_sexo
                  id_parametro_tipo_fondo
                  id_parametro_departamento
                  id_genero
                  correo_personal
                  pais_residencia
                  cuenta_facebook
                  cuenta_twitter
                  zona

                }
              }
            `
          })
          this.persona = res.persona
          //console.log(this.persona)
        } catch (error) {
          console.log(error)
        }
    },
    recuperarSexo (id_genero) {
      
      if (id_genero == 2) {
        return 'Masculino'
      }
      if (id_genero == 1) {
        return 'Femenino'
      } else {
        return 'No registrado'
      }
    }
  }
};
</script>

<style lang="scss">
.tab-preferencias {
  .v-tabs__wrapper {
    margin: 0 !important;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/admin/ficha_personal/Index.vue